import LottieView from "lottie-react-native";
import { Text } from "react-native-paper";
import { View } from "react-native";

import { Modal, Button, LinkButton } from "../../../components";
import { readableDate } from "../../../utils/dateUtils";
import useIntercom from "../../../hooks/useIntercom";
import config from "../../../config";

export default function SuccessModal({
  visible,
  onClose,
  expirationDate,
}: {
  visible: boolean;
  onClose(): void;
  expirationDate: string;
}) {
  const intercom = useIntercom();

  function learnHowItWorks() {
    intercom.present(config.intercomContent.deferredCompHowItWorks);
  }
  return (
    <Modal {...{ visible, onDismiss: onClose, title: "" }}>
      <View testID="success-modal" className="pt-12 items-center justify-between px-10 py-6 bg-sky-white">
        <View className="items-center">
          <View className="w-28 h-28">
            <LottieView style={{ flex: 1 }} autoPlay source={require("../../../../assets/lottie-icons/checklist.json")} />
          </View>
          <Text className="text-title-2 font-700 text-ink-darkest mt-8">Sent for Review</Text>
          <Text className="text-title-5 font-300 text-ink-darkest mt-4">This submission will expire on:</Text>
          <Text className="text-regular-normal font-700 text-ink-dark mt-3 px-4 text-center">
            {readableDate(expirationDate)}
          </Text>
          <Text className="text-regular-normal font-400 text-ink-dark mt-6 mb-4 px-4 text-center">
            Next, your designated Member will review the activity. Your reviewer must confirm the activity on or before its
            expiration date in order to receive points.
          </Text>

          <LinkButton onPress={learnHowItWorks}>Learn how it works</LinkButton>
        </View>

        <View className="w-full mt-8 mb-4">
          <Button mode="secondary" onPress={onClose}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
